import { ref, computed } from 'vue';

const chatClientConfig = ref(null);
const shouldRenderChatClient = ref(false);

const useChatClientWeb = () => {
  const startChatClientWeb = ({
    launchCode,
    launchIdentifier,
    locale,
    systemMode,
    productName,
  }) => {
    chatClientConfig.value = {
      clientHost: window.AppData.supportChatClientBaseUrl,
      clientId: window.AppData?.clientId,
      templateId: window.AppData?.supportChatClientTemplateId,
      dynamicEntitySystemName: launchCode,
      launchIdentifier,
      chatSource: `Support Center - ${systemMode}`,
      locale,
      customerLocale: locale,
      referrerURL: window.location.href,
      queue: launchIdentifier,
      productName,
    };
    shouldRenderChatClient.value = true;
  };

  const onChatClientIsActive = (event) => {
    shouldRenderChatClient.value = Boolean(event?.detail?.value);
  };

  return {
    chatClientConfig,
    shouldRenderChatClient: computed(
      () => shouldRenderChatClient.value && Boolean(chatClientConfig.value),
    ),
    startChatClientWeb,
    onChatClientIsActive,
  };
};

export default useChatClientWeb;
